import { Injectable, inject, signal } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoadingService {
  private router = inject(Router);

  private navigatingState = signal<boolean>(false);
  isNavigating = this.navigatingState.asReadonly();

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.navigatingState.set(true);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.navigatingState.set(false);
      }
    });
  }
}
